/*
 * @File Name: 工具类
 * @Author: zhuzhaoyang
 * @Date: 2023-07-14 15:01:10
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-02-24 17:01:57
 * @Description:
 * @FilePath: \process-portal\src\utils\util.ts
 */
import { encryptAES } from '@/utils/encryption/crypto-js.js';

export default class Util {
  // 根据参数名获取 url 参数
  public static getUrlParam(paraName: string): string {
    const url = document.location.toString();
    const arrObj = url.split('?');
    if (arrObj.length > 1) {
      const arrPara = arrObj[1].split('&');
      let arr;
      for (let i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split('=');
        if (arr != null && arr[0] === paraName) {
          return decodeURI(arr[1]);
        }
      }
      return '';
    } else {
      return '';
    }
  }
  /**
   * @FunctionName: 根据lastname返回 渐变背景色
   * @param {*} lastname 用户的姓
   * @return {*}
   * @Author: zhuzhaoyang
   * @Date: 2021-01-14 18:04:20
   * @Modification history:
   * @Description:
   */
  public static getBackgroundColorByLastName(lastname:string) {
    // 数字  #1F98F3
    const number = new RegExp(/^[0-9]+$/);
    // 字母 a-g #FC764D
    const letter_ag = new RegExp(/^[A-Ga-g]+$/);
    // 字母 h-n #FF9804
    const letter_hn = new RegExp(/^[H-Nh-n]+$/);
    // 字母 o-u #8CC24B
    const letter_ou = new RegExp(/^[O-Uo-u]+$/);
    // 字母 v-z #00BDD6
    const letter_vz = new RegExp(/^[V-Zv-z]+$/);
    // 其它 #DC5EF2

    // 设置头像背景颜色
    let avatarColor = '';
    let str = '';
    if (lastname) {
      if(typeof lastname !== 'string'){
        lastname = String(lastname)
      }
      str = lastname.charAt(0);
    }
    if (number.test(str)) {
      avatarColor = 'linear-gradient(0deg, rgba(250, 156, 15, 0.2), rgba(250, 156, 15, 0.2)), #FFFFFF';
    } else if (letter_ag.test(str)) {
      avatarColor = 'linear-gradient(0deg, rgba(0, 186, 130, 0.2), rgba(0, 186, 130, 0.2)), #FFFFFF';
    } else if (letter_hn.test(str)) {
      avatarColor = 'linear-gradient(0deg, rgba(9, 141, 254, 0.2), rgba(9, 141, 254, 0.2)), #FFFFFF';
    } else if (letter_ou.test(str)) {
      avatarColor = 'linear-gradient(0deg, rgba(68, 105, 236, 0.2), rgba(68, 105, 236, 0.2)), #FFFFFF';
    } else if (letter_vz.test(str)) {
      avatarColor = 'linear-gradient(0deg, rgba(123, 82, 235, 0.2), rgba(123, 82, 235, 0.2)), #FFFFFF';
    } else {
      // 其它
      avatarColor = 'linear-gradient(0deg, rgba(241, 53, 73, 0.2), rgba(241, 53, 73, 0.2)), #FFFFFF';
    }
    return avatarColor;
  }
  /**
   * @FunctionName: 根据lastname返回 背景图片
   * @param {*} lastname 用户的姓
   * @return {*}
   * @Author: zhuzhaoyang
   * @Date: 2021-01-14 18:04:20
   * @Modification history:
   * @Description: sex : man/woman
   */
  public static getBackgroundPictureByLastName(lastname:string,sex:string) {
    // 数字  #1F98F3
    const number = new RegExp(/^[0-9]+$/);
    // 字母 a-g #FC764D
    const letter_ag = new RegExp(/^[A-Ga-g]+$/);
    // 字母 h-n #FF9804
    const letter_hn = new RegExp(/^[H-Nh-n]+$/);
    // 字母 o-u #8CC24B
    const letter_ou = new RegExp(/^[O-Uo-u]+$/);
    // 字母 v-z #00BDD6
    const letter_vz = new RegExp(/^[V-Zv-z]+$/);
    // 其它 #DC5EF2

    // 设置头像背景颜色
    let avatarPicture = '';
    let str = '';
    if (lastname) {
      if(typeof lastname !== 'string'){
        lastname = String(lastname)
      }
      str = lastname.charAt(0);
    }
    if (number.test(str)) {
      avatarPicture = 'imgs/user/yellow_'+sex+'.png';
    } else if (letter_ag.test(str)) {
      avatarPicture = 'imgs/user/green_'+sex+'.png';
    } else if (letter_hn.test(str)) {
      avatarPicture = 'imgs/user/lakeBlue_'+sex+'.png';
    } else if (letter_ou.test(str)) {
      avatarPicture = 'imgs/user/blue_'+sex+'.png';
    } else if (letter_vz.test(str)) {
      avatarPicture = 'imgs/user/purple_'+sex+'.png';
    } else {
      // 其它
      avatarPicture = 'imgs/user/red_'+sex+'.png';
    }
    return require(`@/assets/${avatarPicture}`);
  }
  /**
   * @FunctionName: 获取路径参数
   * @param {*} urlStr
   * @return {*}
   * @Modification history:
   * @Description:
   */
  public static getRequestParam(urlStr:any) {
    const theRequest:any = {}
    const url = decodeURI(urlStr)
    if (url.indexOf('?') !== -1) {
      const str = url.substr(url.indexOf('?') + 1, url.length - 1)
      const strs = str.split('&')
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
      }
    } else {
      return {}
    }
    return theRequest
  }

  /**
   * @FunctionName: 登录加密控制
   * @param {type}
   * @return:
   * @Author: zhuzhaoyang
   * @Date: 2020-03-03 16:28:22
   * @Modification history:
   * @Description:
   */
  public static ASE_Login(val:any) {
    // 加密控制开关
    if ((window as any).serverConfig.AES_LOGIN) {
      val = encryptAES(val);
    }
    return val;
  }
}
